import type { Product } from '#bv/data/products'
import { StarRatingPink } from '#bv/components/FeatureIcons'
import { BundleTierList } from '#bv/components/BundleTierList'
import { ServerBoostProductPurchase } from '#bv/components/ServerBoostProductPurchase'
import { productCardBlurb } from '#bv/lib/productCardCopy'

type Props = {
  product: Product & { bundlePicker: NonNullable<Product['bundlePicker']> }
  catalogBrand: string
  catalog: Product[]
  highlightTierId?: number
  inStock: (id: number) => boolean
  serverBoostListing: Product | null
}

export function BundleProductPanel({
  product,
  catalogBrand,
  catalog,
  highlightTierId,
  inStock,
  serverBoostListing,
}: Props) {
  const ratingText = product.rating.toFixed(1)
  const listingBlurb = productCardBlurb(product) ?? product.shortDescription

  return (
    <div className="pc-pdp-panel">
      <p className="pc-pdp-panel__kicker">{catalogBrand}</p>
      <h1 className="pc-pdp-panel__title font-display chrome-text">{product.name}</h1>

      <div className="pc-pdp-panel__rating-pill">
        <StarRatingPink rating={product.rating} size={16} />
        <span className="font-bold tabular-nums text-[#00bfff]">{ratingText}</span>
        <span className="pc-pdp-panel__rating-sep" aria-hidden />
        <span className="pc-pdp-panel__rating-count">({product.reviewCount.toLocaleString()} reviews)</span>
      </div>

      {listingBlurb ? <p className="pc-pdp-panel__blurb">{listingBlurb}</p> : null}

      <div id="product-purchase" className="pc-pdp-panel__purchase scroll-mt-24">
        <p className="pc-pdp-panel__options-label">Choose a tier</p>
        <div className="mt-3">
          <BundleTierList
            tiers={product.bundlePicker.tiers}
            catalog={catalog}
            inStock={inStock}
            highlightTierId={highlightTierId}
            layout="compare"
          />
        </div>

        {serverBoostListing ? (
          <div className="mt-6 border-t border-white/[0.06] pt-5">
            <p className="m-0 text-[0.62rem] font-bold uppercase tracking-[0.16em] text-[#5a6d8a]">
              Server boost packages
            </p>
            <p className="mt-1 text-xs text-[#5a6d8a]">1-month presets — 14× unlocks Level 3.</p>
            <div className="mt-3">
              <ServerBoostProductPurchase product={serverBoostListing} variant="compact" />
            </div>
          </div>
        ) : null}
      </div>
    </div>
  )
}
